module.exports = __webpack_public_path__ + "media/yqScreenVideo.d4831086.mp4";